<template>
  <div>
    <a href="https://www.biopama.org/"> <span class="popup-close">+</span> </a>
    <div class="left-panel">
      <div class="left-inner">
        <div class="language-switch-container">
          <locale-switch></locale-switch>
        </div>
        <div class="lp-signup">
          <p>{{$t("auth.register__top_line")}}</p>
          <router-link to="/auth/login" class="btn btn-primary btn-simple">{{$t("auth.btn_login")}}</router-link>
        </div>

        <h1></h1>
        <p class="disclaimer-browser">{{$t('general.disclaimer_browser')}}</p>
        <h3>{{ $t("auth.register__subtitle") }}</h3>

        <form v-if="!submitted" @submit.prevent="submitRegister">
          <div>
          <span class="lp-form-input">
            <input type="text"
                   v-model="model.email"
                   v-validate="'required|email'"
                   name="email"
                   class="form-control"
                   :class="{ 'has-danger': getError('email') }"
            />
            <label for="email">{{ $t('auth.input_email') }}</label>
                        <span v-if="getError('email')" class="has-error">{{getError('email')}}</span>
            </span>

            <span class="lp-form-input">
               <input type="password"
                      v-model="model.password"
                      v-validate="'required|min:5'"
                      data-vv-as="password"
                      name="password"
                      class="form-control"
                      :class="{ 'has-danger': getError('password') }"
                      ref="password"
               />
            <label for="password">{{ $t('auth.input_password') }}</label>
              <span v-if="getError('password')" class="has-error">{{ getError('password') }}</span>
          </span>


            <span class="lp-form-input">
               <input type="password"
                      v-model="model.passwordConfirmation"
                      v-validate="'required|confirmed:password'"
                      data-vv-as="password confirmation"
                      name="password_confirmation"
                      class="form-control"
                      :class="{ 'has-danger': getError('password_confirmation') }"
               />
            <label for="confirm">{{ $t('auth.input_confirm_password') }}</label>
              <span v-if="getError('password_confirmation')" class="has-error">{{ getError('password_confirmation') }}</span>
          </span>


          </div>

          <base-checkbox class="terms-label mt-4" :class="{ 'has-danger': getError('terms') }" name="terms" v-validate="'required:true'" v-model="model.terms" inline>
            <i18n path="auth.register__terms_agree" tag="span">
              <a href="https://biopama.org/cookie-privacy-policy/" target="_blank">{{ $t('auth.register__terms') }}</a>
              <!-- <a href="https://biopama.org/cookie-privacy-policy/" target="_blank">{{ $t('auth.register__privacy') }}</a> -->
            </i18n>
          </base-checkbox>
          <base-checkbox class="terms-label" :class="{ 'has-danger': getError('termsIucn') }" name="termsIucn" v-validate="'required:true'" v-model="model.termsIucn" inline>
            <i18n path="auth.register__terms_iucn" tag="span">
              <a href=" https://www.iucn.org/privacy-policy" target="_blank">{{ $t('auth.register__privacy_iucn') }}</a>
            </i18n>
          </base-checkbox>

          <div slot="footer">
            <button class="btn btn-lg btn-primary submit-button" :class="{'disabled': loading}" :disabled="loading" type="submit">{{ $t('auth.btn_register')}}</button>
          </div>
        </form>
        <div v-if="submitted && success" class="white-space-pre-line">
          <p>
            {{ $t('auth.register__submitted') }}
          </p>
          <p>
            {{ $t('auth.register__submitted_confirm') }}
          </p>
          <p>
            {{ $t('auth.register__submitted_thanks') }}
          </p>
        </div>

        <div v-if="submitted && !success">
          <p>
            {{ $t('auth.register__not_registered') }}
          </p>
        </div>

      </div>
    </div>
    <div class="right-panel">
      <canvas class="strength-indicator" width="628" height="679"></canvas>
    </div>
  </div>
</template>


<script>
  import {PasswordStrengthInit} from "@/helpers";
  import LocaleSwitch from "@/components/LocaleSwitch";
  import {AuthService} from "@/services";

  export default {
    data() {
      return {
        model: {
          email: '',
          password: '',
          passwordConfirmation: '',
          terms: false
        },
        loading: false,
        submitted: false,
        success: false
      };
    },
    components: {
      LocaleSwitch
    },
    methods: {
      async submitRegister() {
        let isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          this.loading = true;

          await AuthService.register({
            email: this.model.email,
            password: this.model.password,
            passwordConfirmation: this.model.passwordConfirmation,
            language: this.$i18n.locale
          }).then((response) => {
            this.success = true;
            this.submitted = true;

          }).catch((error) => {
            let message = error.data.message;

            for (let key in message) {
              const fieldName = this._.snakeCase(key);
              const langKey = message[key];

              let data = fieldName === 'email' ? this.model.email : fieldName;

              this.$validator.errors.add({
                field: fieldName,
                msg: this.$validator.dictionary.getMessage(this.$i18n.locale, langKey, [data]),
                regenerate: () => this.$validator.dictionary.getMessage(this.$i18n.locale, langKey, [data])
              });
            }

          })

          this.loading = false;
        }

      },
      getError: function (fieldName) {
        return this.errors.first(fieldName);
      }
    },
    mounted() {
      PasswordStrengthInit();
    }
  };
</script>
<style lang="scss" scoped>
  .disclaimer-browser {
    max-width: 25rem;
  }
  h1 {
    margin-top: 12.927083vh;
  }
  h3 {
    /*margin-bottom: 7.020833vh;*/
    margin-top: 2vh;
    margin-bottom: 4.020833vh;
  }

  .full-page .content .lp-form-input {
    margin-top: 4.327083vh;
  }
  .terms-label {
    font-size: 1.62291667vh;
    font-weight: 400;
    color: $secondary;

    &.has-danger {
      a {
        color: $danger;
      }
    }

    a {
      text-decoration: underline;
    }
  }
</style>
